import React from "react";

export default function Breadcrumbs({ items }) {
  return (
    <div className="breadcrumbs_container">
      {items.map((item, idx) => (
        <React.Fragment key={item.label}>
          <p
            className={`breadcrumbs_item ${
              item.active ? "breadcrumbs_active" : ""
            } ${item.onClick ? "breadcrumbs_clickable" : ""}`}
            onClick={item.onClick}
            onMouseEnter={item.onMouseEnter}
            onMouseLeave={item.onMouseLeave}
          >
            {item.label}
          </p>

          {idx < items.length - 1 && (
            <p className="breadcrumbs_separator">{">"}</p>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
